import React from "react";
import { useAppSelector } from "../../redux/hook";
import OrderModalBody from "./components/OrderModalBody";

export default function CurrentOrders({ orders }) {
  const { orderStatus } = useAppSelector((state) => state.componentReducer);

  return <OrderModalBody orderStatus={orderStatus} orders={orders} />;
}
